import React, { FC, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const CustomizerTest = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "testingCustomizer" */ 'src/components/widgets/customizerTest/customizerTest')
);

const shimmer = keyframes`
	0% { background-position: 200% 0; }
	100% { background-position: -200% 0; }
`;

const SkeletonOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f5f7fa;
    z-index: 20;
    display: flex;
    flex-direction: column;
`;

const SkeletonTopBar = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 12px 24px;
    background: white;
    border-bottom: 1px solid #e2e8f0;
    min-height: 64px;
    gap: 16px;
`;

const SkeletonBlock = styled.div<{ $width: string; $height: string; $round?: boolean }>`
    width: ${(p) => p.$width};
    height: ${(p) => p.$height};
    border-radius: ${(p) => (p.$round ? '50%' : '8px')};
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
    background-size: 200% 100%;
    animation: ${shimmer} 1.5s ease-in-out infinite;
`;

const SkeletonContent = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const PreviewSkeleton: FC = () => (
    <SkeletonOverlay>
        <SkeletonTopBar>
            <SkeletonBlock $width='36px' $height='36px' $round />
            <SkeletonBlock $width='180px' $height='22px' />
            <div style={{ flex: 1 }} />
            <SkeletonBlock $width='100px' $height='32px' />
            <SkeletonBlock $width='36px' $height='36px' $round />
        </SkeletonTopBar>
        <SkeletonContent>
            <SkeletonBlock $width='60%' $height='70%' />
        </SkeletonContent>
    </SkeletonOverlay>
);

const TestingCustomizerPage: FC<{}> = () => {
    // Url parameters
    const urlParams = useParams();

    if (!urlParams.productId) throw new Error('Invalid product id');

    return (
        <Suspense fallback={<PreviewSkeleton />}>
            <CustomizerTest productId={urlParams.productId} showCopyUrl />
        </Suspense>
    );
};

export default TestingCustomizerPage;
